import { module } from 'modujs';
import { slideUp, slideDown } from '../utils/slide';

const ITEM_ACTIVE_CLASS = 'is-active';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                'button': 'onButtonClick',
            },
        };
    }

    onButtonClick(event) {
        // Get matching item
        const target = this.parent('item', event.curTarget);

        // Get parent list
        const list = target.parentNode;

        // Close every other item in this list
        for (const child of Array.from(list.children)) {
            if (child !== target) {
                this.closeItem(child);
            }
        }

        // Toggle current item
        this.toggleItem(target);
    }

    toggleItem(target) {
        if (target.classList.contains(ITEM_ACTIVE_CLASS)) {
            this.closeItem(target);
        } else {
            this.openItem(target);
        }
    }

    openItem(target) {
        // Get the content el and open it w/ animation
        const content = this.$('content', target)[0];

        if (content) {
            slideDown(content);
        }

        // Add active clas on item for style & status
        target.classList.toggle(ITEM_ACTIVE_CLASS);
    }

    closeItem(target) {
        // Trigger close action only if currently active
        if (target.classList.contains(ITEM_ACTIVE_CLASS)) {
            // Get the content el and close it w/ animation
            let content = this.$('content', target)[0];

            if (content) {
                slideUp(content);
            }
            // Remove active clas on item for style & status
            target.classList.remove(ITEM_ACTIVE_CLASS);

            for (let item of this.$('item', target)) {
                this.closeItem(item);
            }
        }
    }
}
